/**
 * UI-related translations for English language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: 'Copy link',
    discord: 'Discord',
    leaveGame: 'Leave Game',
    joinGame: 'Join Game',
    lockGame: 'Lock Game',
    unlockGame: 'Unlock game',
    startGame: 'Start Game',
    options: 'Options',
  },
  onlineStatus: {
    connecting: 'Connecting...',
    connected: 'Connected',
    error: 'Error',
  },
  profile: {
    username: 'Username',
    stats: 'Statistics',
    logout: 'Logout',
    language: 'Language',
    hideSpoilersHint: 'Hide spoilers',
    hideIndexHint: 'Hide Indexes In History',
    animeMode: 'Anime mode',
    change: 'Change',
    colorTheme: 'Color theme',
    darkTheme: 'Dark theme',
    lightTheme: 'Light theme',
    changePassword: 'Change password',
    profile: 'Profile',
    settings: 'Settings',
  },
  breadCrumbs: {
    merlin: 'Merlin',
    merlin_pure: 'Merlin Pure',
    guinevere: 'Guinevere',
    percival: 'Percival',
    lovers: 'Lovers',
    troublemaker: 'Troublemaker',
    servant: 'Servant',
    lancelots: 'Lancelots',
    mordred: 'Mordred',
    trickster: 'Trickster',
    revealer: 'Revealer',
    morgana: 'Morgana',
    oberon: 'Oberon',
    lunatic: 'Lunatic',
    brute: 'Brute',
    witch: 'Witch',
    minion: 'Minion',
    cleric: 'Cleric',
    wiki: 'Wiki',
    expansions: 'Expansions',
    roles: 'Roles',
    lady: 'Lady',
    lady_sea: 'Lady Sea',
    plot_cards: 'Plot Cards',
    excalibur: 'Excalibur',
    rules: 'Rules',
  },
  hostMenu: {
    host: 'Admin',
    hostPanel: 'Admin panel',
    endRestartGameHint: 'Buttons are used to vote for ending or restarting the game',
    endGame: 'End game',
    restartGame: 'Restart game',
    shuffle: 'Shuffle',
    shuffleHint: 'Shuffle players in the lobby',
  },
  cardsInfo: {
    cards: 'Cards',
    usedCards: 'Used cards',
    remainingCards: 'Remaining cards',
    leadToVictory: 'Lead to victory',
    leadToVictoryHint: 'Become the leader before team selection',
    ambush: 'Ambush',
    ambushHint: 'Reveal the result of one card from the mission',
    kingReturns: 'King returns',
    kingReturnsHint: 'Cancel an approved mission and pass leadership to the next player',
    restoreHonor: 'Restore your honor',
    restoreHonorHint: 'Take a plot card from any player',
    charge: 'Charge',
    chargeHint: 'Force a player to vote publicly',
    showNature: 'Show your true nature',
    showNatureHint: 'Reveal your loyalty to another player',
    areYouTheOne: 'Are you the one',
    areYouTheOneHint: 'Check the loyalty of an adjacent player',
    weFoundYou: 'We found you',
    weFoundYouHint: 'Force one player to play their mission card openly',
    showStrength: 'Show your strength',
    showStrengthHint: 'Leader reveals their loyalty to a player',
  },
  avatars: {
    modalHeader: 'Avatar selection',
    servantHint: 'Standard avatar',
    lady_of_lakeHint: 'Awarded to users registered in 2025',
    mysteryHint: 'Awarded to users who found a secret on the site',
    merlin_pureHint: 'Awarded for helping the project with feedback / bug finding',
    'anime/merlin_pureHint': 'Awarded for any contribution to the project code on GitHub',
    'anime/witchHint': 'Awarded for reaching top-1 rating on any role',
  },
  spoiler: {
    spoiler: 'Spoiler',
    spoilerHint: 'Content is hidden under a spoiler as it contains information unknown to other players',
  },
  previewLink: {
    'Minions of Mordred(*)': 'Minions of Mordred(*)',
    Minions: 'Minions',
  },
  chartStats: {
    countPlayer: '{playerCount} players',
    evilWinrate: 'Evil forces win rate',
    goodWinrate: 'Good forces win rate',
    winrateByTeamSize: 'Win rate by team size',
    halfWinrate: '50% wins',
  },
  inGame: {
    sendTeam: 'Send team',
    approve: 'Approve',
    reject: 'Reject',
    success: 'Success',
    fail: 'Fail',
    checkLoyalty: 'Check loyalty',
    giveExcalibur: 'Give Excalibur',
    skipExcalibur: 'Skip Excalibur',
    useExcalibur: 'Use Excalibur',
    useWitchAbility: 'Hide mission',
    skipWitchAbility: 'Skip',
    giveCard: 'Give card',
    takeLead: 'Take leadership',
    skip: 'Skip',
    useCard: 'Use {cardName}',
    skipCard: 'Skip {cardName}',
    selectPlayer: 'Select player',
    selectSinglePlayer: 'Please select only one player',
    cannotSelectSelf: 'You cannot select yourself',
    takeCard: 'Take card',
    selectCard: 'Select card',
    noAvailableCards: 'No available cards',
    revealLoyalty: 'Reveal loyalty',
  },
};
